<button mat-raised-button color="primary" (click)="openQueueWarningModal()">
  {{ "ONSIP_I18N.SET_QUEUE_ALERTS" | translate }}
</button>
